import React from "react";
import Confirm from "../Generic/ConfirmDialog";
import FormNumberRow from "../../components/Generic/Form/Numeric/";
import { iActionProps, iEnquiry } from "../../interfaces/iEnquiry";
import { PrioritiseEnquiries, PrioritiseEnquiriesRequest } from "../../Logic/EmsAPI/Enquiries";

interface Props extends iActionProps {
    enquiries: Array<iEnquiry>;
}
function ChangeEnquiryPriority(props: Props) {
    const [NewValue, SetNewValue] = React.useState(props.enquiries[0].priority.toString());

    function isValidWorkItem(): boolean {
        if (+NewValue < 1 || +NewValue > 255) {
            return false;
        }
        return true;
    }
    function handleChange(value: string) {
        if (value != "") {
            SetNewValue(value);
        }
    }
    async function Submit() {
        if (NewValue !== "" && isValidWorkItem()) {
            let prioritiseEnquiriesRequest: PrioritiseEnquiriesRequest = {
                Priority: +NewValue,
                Enquiries: props.enquiries.map(enq => enq.id),
            };
            const response = await PrioritiseEnquiries(prioritiseEnquiriesRequest);
            if (!response.isOk) {
                props.onError("Unable to prioritise enquiries.", response.errorLogID);
                return;
            }
            props.onCreated();
        }
    }
    return (
        <>
            <Confirm
                title="Change Enquiry Priority"
                onCancel={props.onCancel}
                onConfirm={Submit}
                isValid={true}
            >
                <div style={{ fontWeight: "bold" }}>Set the priority of the selected enquiries to:</div>
                <div style={{ width: "80px", marginTop: "5px" }}>
                    <FormNumberRow
                        label=""
                        requiredIdentifier={true}
                        value={props.enquiries[0].priority}
                        isNotValid={!isValidWorkItem()}
                        onChange={newValue => {
                            handleChange(newValue);
                        }}
                        key={"mis-field-Items"}
                        id={"15"}
                        min={1}
                        max={255}
                    ></FormNumberRow>
                </div>
                <div>1 = Highest Priority</div>
                <div>255 = Lowest Priority</div>
            </Confirm>
        </>
    );
}

export default ChangeEnquiryPriority;
